import {ReportFileFiltersType} from "../hooks/useCentralReportFileQuery";

export const ReportFileInitialValue: ReportFileFiltersType = {
    type: undefined,
    name: undefined,
    reportDate: null,
    operatorId: undefined,
}; 